export const ROUTES = {
  home: "/",
  loginpage: "/login",
  forgotPassword: "/forgotpassword",
  changePassword: "/changePassword",
  officer: "/officer",
  admin: "/admin",
  guest: "/guest",
} as const;

export const OFFICER_ROUTES = {
  reservationList: `${ROUTES.officer}/listreservation`,
  walkInReservationList: `${ROUTES.officer}/listwalkin`,
} as const;

export class BasicRoutes {
  constructor(private base: string) {}

  get home() {
    return this.base.length ? this.base : "/";
  }

  get loginpage() {
    return `${this.base}/login`;
  }

  get admin() {
    return `${this.base}/admin`;
  }
  get guest() {
    return `${this.base}/guest`;
  }
  get officer() {
    return `${this.base}/officer`;
  }

  get scan_qr() {
    return `${this.admin}/scan`;
  }
  get guest_scan_qr() {
    return `${this.guest}/scan`;
  }

  get safety_check_inactive() {
    return `${this.admin}/safetycheck-inactive`;
  }

  get vehicle_list() {
    return `${this.admin}/list`;
  }
  get vehicle_detail() {
    return `${this.admin}/detail`;
  }
  get guest_vehicle_detail() {
    return `${this.guest}/detail`;
  }

  get vehicle_checklist() {
    return `${this.admin}/checklist`;
  }

  get result() {
    return `${this.admin}/result`;
  }
}

export const combinedRoutes = new BasicRoutes("");
